var windowWidth;

/**
 * On page load
 **/
$(document).ready( function(){
	// Start your website!
    windowWidth = $(window).width();
	PageSetup();
});


function PageSetup(){
    MobileNav();
    if(windowWidth <= 550){
        ToggleContent();
    }
    ToggleContent();
    ToggleImageCaptions();
    SignUpForm();
}

function MobileNav(){
    $('.hamburglar').click( function(){
        $(this).toggleClass('open');
        $('.mainnav').toggleClass('open');
        // $('.mainnav').slideToggle();
    });
}

function ToggleContent(){
    $('.expander').click(function(e){
        $(this).toggleClass('open');
        e.preventDefault();
        $(this).parent('.foo').parent('.togglable').children('.togglable-content').slideToggle(200);
        $(this).parent('.foo').toggleClass('open');
    });
}


$(window).resize(function(){
    windowWidth = $(window).width();
    if(windowWidth <= 550){
        ToggleContent();
    }
});




function ToggleImageCaptions(){
    
    $('.credited-image .toggle').stop().click(function(){
        
        var target = $(this).siblings('.details');
        
        if($(this).hasClass('fadein')){
            target.fadeIn(100);
        }else{
            target.fadeOut(100);
        }
        
        $(this).toggleClass('fadein fadeout');
        
    });
    
}

/** 
 * Load more homepage featured items
 **/
$(document).on('click', '.homepage-featured-categories.show-more', function(event){
    
    var trigger = $(this);
    var wrapper = $(this).closest('.show-more-wrapper');
    
    // prevent us from going to the link
    event.preventDefault();
    
    // request more, and see what Mr Controller has for us
    $.get( $(this).attr('href') )
        .then( function( data ){        
            trigger.before( data );
        });
        
    trigger.hide();
    
});


/**
 * Sign Up Submissions
 */
function SignUpForm(){
    $('input[name=Member]').change(function() {
        $('.hide.member').toggle();

        $('.hide.member :input').attr('required', 'required')
        
    });

    $('#Form_SignUpForm_Region').change(function() {        
        $('#Form_SignUpForm_Region input[type=checkbox]').each(function() 
        { 
            $(this).removeAttr('required');
        });
    });

    $('#Form_SignUpForm_OpSector ').change(function() {        
        $('#Form_SignUpForm_OpSector input[type=checkbox]').each(function() 
        { 
            $(this).removeAttr('required');
        });
    });
    

    if($('input[name=Member]:checked').val() == 'Yes') {
        $('.hide.member :input').each(function() {
            $(this).removeAttr('required')
        });
    }

    if($('input[name=Member]:checked').val() == 'No') {
        $('.hide.member').toggle();
  
    }
}

// Browse/filter forms
var checkbox_dropdown = $('.apply-dropdown');
var trigger = checkbox_dropdown.find('label.left');

trigger.click(function(){
    $(this).closest(checkbox_dropdown).toggleClass('open');
    $(this).next().removeClass('hide');
});

$('label:not(.left), input').on('click', function () {
    
    // $(this).closest(checkbox_dropdown).parent().addClass('hide');
    // $(trigger).closest(checkbox_dropdown).removeClass('open');
    //$('.open').toggleClass();

});
